export const ADD_FILTER = 'ADD_FILTER';
export function addFilter(name, value){
	return { type: ADD_FILTER, name, value }
}

export const REMOVE_FILTER = 'REMOVE_FILTER';
export function removeFilter(name, value){
	return { type: REMOVE_FILTER, name, value }
}

export const CLEAR_FILTER = 'CLEAR_FILTER';
export function clearFilter(){
	return { type: CLEAR_FILTER }
}

export const TOGGLE_FILTER = 'TOGGLE_FILTER';
export function toggleFilter(name, value){
	return { type: TOGGLE_FILTER, name, value }
}

export const SET_FILTER_TEXT = 'SET_FILTER_TEXT';
export function setFilterText(text){
	return { type: SET_FILTER_TEXT, text }
}

export const SET_FILTER = 'SET_FILTER';
export function setFilter(filter){
	return { type: SET_FILTER, filter }
}



// WEBPACK FOOTER //
// ./wp-content/themes/gwy/assets/scripts/source/vpm/post-grid/actions/filter.js